import { render, staticRenderFns } from "./CreateModelFormPage.vue?vue&type=template&id=30ea4ffe&scoped=true"
import script from "./CreateModelFormPage.vue?vue&type=script&lang=ts"
export * from "./CreateModelFormPage.vue?vue&type=script&lang=ts"
import style0 from "./CreateModelFormPage.vue?vue&type=style&index=0&id=30ea4ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea4ffe",
  null
  
)

export default component.exports